import { render, staticRenderFns } from "./DownloadReport.vue?vue&type=template&id=20b0e2d8&"
import script from "./DownloadReport.vue?vue&type=script&lang=js&"
export * from "./DownloadReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports